import React from 'react';
import { Field } from "redux-form";
import { renderFullTextField } from "../ProductFormField";
import { getCategoriesList } from '../utils';

export const renderProperties = (record, resource, basePath, categories) => {
  let index = 0;
  let dataArray = [];
  if (record.properties !== undefined) {
    let keyArray = getCategoriesList(record.properties,categories.properties);
    for (var key in keyArray) {
      if (keyArray.hasOwnProperty(key)) {
        
        dataArray[index] = (
          <div>
            <Field
              label={keyArray[key]}
              name={`properties.${keyArray[key]}`}
              component={renderFullTextField}
            />
          </div>
        );
        index++;
      }
    }
  }
  return (
    <div>
      {dataArray.map((item, index) => (
        <div key={`items-${index}`}>{item}</div>
      ))}
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/products/edit/PropertiesField.js